var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{staticClass:"policy-menu-item",attrs:{"index":"newPolicy","route":"policy"}},[_c('el-tooltip',{attrs:{"effect":"dark","content":"You have to accept new policy","placement":"bottom"}},[_c('el-button',{attrs:{"type":"danger"}},[_vm._v("New Policy")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-365c16ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderMenuPolicy.vue
// module id = TZiI
// module chunks = 1